import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// Context
import { UserContext } from './context/UserContext';
// Pages
import ServicesPlusLogs from './pages/servicesplus/ServicesPlusLogs';
import CTALogs from './pages/ctalogs/CTALogs';
// Components
import Header from './components/header/Header';
// Actions
import { initAuthToken, Auth } from './actions/authentication';
// Styles
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/app.scss';

function App() {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const token = params.get('t');

  const [user, setUser] = useState(initAuthToken(token));

  useEffect(() => {
    const fetchUserData = async () => {
      const userData = await Auth(user);

      if (userData) {
        setUser({
          ...user,
          ...userData,
        });
      }
    };
    fetchUserData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      {user && user.token && (
        <BrowserRouter>
          <UserContext.Provider value={{ user, setUser }}>
            {/* <Header /> */}
            <Routes>
              <Route path="/ServicesPlus/Logs" element={<ServicesPlusLogs />} />
              <Route path="/CTA/Logs" element={<CTALogs />} />
            </Routes>
          </UserContext.Provider>
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
